var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.011,
    height: 56.011,
    viewBox: "0 0 56.011 56.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4295555_time_analogue_clock_date_hours_icon",
    "data-name": "4295555_time_analogue_clock_date_hours_icon",
    transform: "translate(0 56.011) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M28.006,0A28.006,28.006,0,1,0,56.011,28.006,28.006,28.006,0,0,0,28.006,0Zm0,51.344A23.338,23.338,0,1,1,51.344,28.006,23.338,23.338,0,0,1,28.006,51.344Z",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 3.501,
    height: 3.501,
    transform: "translate(26.255 8.168)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 3.501,
    height: 3.501,
    transform: "translate(8.168 26.255)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 3.501,
    height: 3.501,
    transform: "matrix(0.707, 0.707, -0.707, 0.707, 40.889, 12.645)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 3.501,
    height: 3.501,
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 15.313, 43.176)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 3.501,
    height: 3.501,
    transform: "translate(15.217 12.741) rotate(45)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 3.501,
    height: 3.501,
    transform: "translate(40.794 43.272) rotate(-135)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M40.587,22.5H22.5V44.088H26V26H44.088V22.5Z",
    transform: "translate(3.755 3.755)",
    fill: "#efa462"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.54fb1a12efadd65c69598826e560914e.svg";
export { ForwardRef as ReactComponent };